import { useMemo } from "react";
import { useContextLicenseAgreement } from "@/app/module/index";

export function useMLA() {
  const {
    mlaItem,
    mlaStatus,
    fetchAcceptLicenseAgreement,
    fetchSendEmailLicenseAgreement,
  } = useContextLicenseAgreement();

  return useMemo(
    () => ({
      data: mlaItem,
      status: mlaStatus,
      accept: fetchAcceptLicenseAgreement,
      sendEmail: fetchSendEmailLicenseAgreement,
    }),
    [
      mlaItem,
      mlaStatus,
      fetchAcceptLicenseAgreement,
      fetchSendEmailLicenseAgreement,
    ],
  );
}
